import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate, useParams } from "react-router";
import * as AppConfig from "../../../../helpers/AppConfig";
import { makeApiCall } from "src/api/apiRequests";

import API_PATHS from "src/api/apiPaths";
import PATHS from "src/routes/Paths";
import API_HEADERS from "src/api/apiConfig";
import SearchFilter from "src/helpers/SearchFilter";
import ListResponse from "src/helpers/ListResponse";
import FLASH_MESSAGES from "src/helpers/FlashMessages";
import CustomPagination from "src/helpers/CustomPaginate";
import * as ConfirmPopup from "../../../../helpers/ConfirmPopup";
import Loading from "src/helpers/Loading";

const ShowKindergartenChildren: React.FC = () => {
  const { t } = useTranslation("");
  const param = useParams();

  const [children, setChildren] = useState<Record<string, any>[]>([]);
  const [kindergartenId, setKindergartenId] = useState("");

  const [loading, setLoading] = useState(true);
  const [activePage, setActivePage] = useState<number>(1);
  const [paginate, setPaginate] = useState<any>([]);
  const [modalId, setModalId] = useState<number | null>(null);
  const [modified, setModified] = useState(false);

  const getChildren = async (hasSearch: any | undefined): Promise<void> => {
    setModified(false);
    const kindergartenId = param.id;

    const searchParams: any = {};
    let request: any = API_PATHS.childrenList;

    if (activePage > 1) {
      searchParams["page"] = activePage;
    }

    if (kindergartenId) {
      searchParams["kindergarten_id"] = kindergartenId;
    }

    request = SearchFilter(searchParams, request);

    try {
      const response: any = await makeApiCall<ResponseType>(
        request,
        "GET",
        API_HEADERS.authenticated
      );

      setChildren(response.children.data);
      setPaginate(response.children);
      setLoading(false);
    } catch (error: any) {
    } finally {
    }
  };

  useEffect(() => {
    getChildren("");
  }, [modified, activePage]);

  return (
    <>
      <div className="table-list mb-5">
        <table role="table" className="w-100">
          <thead>
            <tr role="row">
              <th
                style={{ width: "20%" }}
                role="columnheader"
                className="text-left"
              >
                <i className="icon children-name-icon" />
                {t("show_kindergarten_children_name_lastname")}
              </th>
              <th
                style={{ width: "20%" }}
                role="columnheader"
                className="text-center"
              >
                <i className="icon guardian-icon " />
                {t("show_kindergarten_children_guardian")}
              </th>
              <th
                style={{ width: "20%" }}
                role="columnheader"
                className="text-center"
              >
                <i className="icon address-icon" />
                {t("show_kindergarten_children_address")}
              </th>
              <th
                style={{ width: "20%" }}
                role="columnheader"
                className="text-center"
              >
                <i className="icon telephone-icon" />
                {t("show_kindergarten_children_mobile")}
              </th>

              <th
                style={{ width: "20%" }}
                role="columnheader"
                className="text-center"
              >
                <i className="icon email-icon" />
                {t("show_kindergarten_children_email")}
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td className="text-center" colSpan={5}>
                  <Loading />
                </td>
              </tr>
            ) : (
              children.map((child, index) => (
                <tr key={child.id}>
                  <td
                    role="cell"
                    className="text-left bold-text"
                    data-label={t("show_kindergarten_children_name_lastname")}
                  >
                    {(child.first_name ? child.first_name : "-") +
                      " " +
                      (child.last_name ? child.last_name : "-")}
                  </td>
                  <td
                    role="cell"
                    className="text-center"
                    data-label={t("show_kindergarten_children_guardian")}
                  >
                    {(child.guardian.first_name
                      ? child.guardian.first_name
                      : "-") +
                      " " +
                      (child.guardian.last_name
                        ? child.guardian.last_name
                        : "-")}
                  </td>
                  <td
                    role="cell"
                    className="text-center"
                    data-label={t("show_kindergarten_children_address")}
                  >
                    {child.address ? child.address : "-"}
                  </td>
                  <td
                    role="cell"
                    className="text-center"
                    data-label={t("show_kindergarten_children_mobile")}
                  >
                    {child.guardian.phone ? (
                      <a href={`tel:${child.guardian.phone}`}>
                        {child.guardian.phone}
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>
                  <td
                    role="cell"
                    className="text-center blue-text"
                    data-label={t("show_kindergarten_children_email")}
                  >
                    {child.guardian.email ? (
                      <a href={`mailto:${child.guardian.email}`}>
                        {child.guardian.email}
                      </a>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
        <ListResponse totalItems={children.length} loading={loading} />
      </div>
      <CustomPagination
        data={paginate}
        setActivePage={(e) => setActivePage(e)}
      />
    </>
  );
};
export default ShowKindergartenChildren;
